export const INSURANCE_CALC_SET_APPLICATION = 'INSURANCE_CALC_SET_APPLICATION';
export const INSURANCE_CALC_UPD_APPLICATION = 'INSURANCE_CALC_UPD_APPLICATION';
export const INSURANCE_CALC_UPD_APPL_PARAMS = 'INSURANCE_CALC_UPD_APPL_PARAMS';
export const INSURANCE_CALC_SET_SELECTED_OFFER = 'INSURANCE_CALC_SET_SELECTED_OFFER';
export const INSURANCE_CALC_UPD_OFFER = 'INSURANCE_CALC_UPD_OFFER';
export const INSURANCE_CALC_AGREEMENT = 'INSURANCE_CALC_AGREEMENT';

export const INSURANCE_CALC_SELECT_OFFER_REQUEST = 'INSURANCE_CALC_SELECT_OFFER_REQUEST';
export const INSURANCE_CALC_AGREEMENT_REQUEST = 'INSURANCE_CALC_AGREEMENT_REQUEST';
export const INSURANCE_CALC_GET_POLICY_REQUEST = 'INSURANCE_CALC_GET_POLICY_REQUEST';

export const INSURANCE_CALC_CLIENT_DECLINE_REQUEST = 'INSURANCE_CALC_CLIENT_DECLINE_REQUEST';
export const INSURANCE_CALC_REFRESH_CALC_REQUEST = 'INSURANCE_CALC_REFRESH_CALC_REQUEST';
export const INSURANCE_CALC_REFRESH_CALCS_BY_APPS_IDS_REQUESTS =
  'INSURANCE_CALC_REFRESH_CALCS_BY_APPS_IDS_REQUESTS';
export const INSURANCE_CALC_ADD_INSURANCE_ORDER_REQUEST =
  'INSURANCE_CALC_ADD_INSURANCE_ORDER_REQUEST';
export const INSURANCE_CALC_CANCELLATION_REQUEST = 'INSURANCE_CALC_CANCELLATION_REQUEST';
export const INSURANCE_CALC_RELOAD_DOCS_REQUEST = 'INSURANCE_CALC_RELOAD_DOCS_REQUEST';

export const INSURANCE_CALC_ADD_FILE = 'INSURANCE_CALC_ADD_FILE';
export const INSURANCE_CALC_DEL_FILE = 'INSURANCE_CALC_DEL_FILE';

export const INSURANCE_CALC_SET_FETCH = 'INSURANCE_CALC_SET_FETCH';
export const INSURANCE_CALC_SET_MAIN_FETCH = 'INSURANCE_CALC_SET_MAIN_FETCH';
export const INSURANCE_CALC_SET_NAMEPLATE = 'INSURANCE_CALC_SET_NAMEPLATE';

export const INSURANCE_CALC_SET_DEALER_LEGALS = 'INSURANCE_CALC_SET_DEALER_LEGALS';
export const INSURANCE_CALC_UPD_DEALER_LEGALS = 'INSURANCE_CALC_UPD_DEALER_LEGALS';

export const INSURANCE_CALC_SET_POPUP_DATA = 'INSURANCE_CALC_SET_POPUP_DATA';

export const INSURANCE_SET_RISKS = 'INSURANCE_SET_RISKS';
export const INSURANCE_UPDATE_RISKS = 'INSURANCE_UPDATE_RISKS';

export const INS_REQUEST_PRELIST = 'insurance/calculation/prelist';
export const INS_SET_ID = 'insurance/calculation/set-id';
export const INS_SET_ERROR = 'insurance/calculation/set-error';
export const INS_SET_ERRORS = 'insurance/calculation/set-errors';

export const INS_DROP_ALL_ERRORS = 'insurance/calculation/drop-all-errors';
export const INS_DROP_ALL = 'insurance/calculation/drop-all';

export const INS_SET_IS_IN_CREDIT = 'insurance/calculation/set-is-in-credit';
export const INS_GET_BANKS_LIST = 'insurance/calculation/get-banks-list';
export const INS_SET_BANKS_LIST = 'insurance/calculation/set-banks-list';
export const INS_SET_SELECTED_BANK = 'insurance/calculation/set-selected-bank';

export const INS_REQUEST_BYORDER = 'insurance/calculation/request-by-order';
export const INS_SET_MULTIDRIVE = 'insurance/calculation/set-multidrive';

export const INSURANCE_CALC_RECALC_RECUSTOMERS = 'INSURANCE_CALC_RECALC_RECUSTOMERS';

export const INS_SET_BANKS_FETCH = 'insurance/calculation/set-banks-fetch';
export const INS_GET_APPLICATION_DATA = 'insurance/calculation/get-application-data';
export const INS_BATCH_STATE = 'insurance/calculation/batch-state';

export const FIELDS = {
  APPLICATION_ID: 'applicationId',
  APPLICATIONS: 'applications',
  APPLICATIONS_POPUP_DATA: 'applicationsPopupData',
  BANKS_FETCH: 'banksFetch',
  CURRENT_MULTIDRIVE: 'currentMultidrive',
  DEALER_LEGALS: 'dealerLegals',
  ERROR: 'error',
  ERRORS: 'errors',
  FETCH_STATES: 'fetchStates',
  INSURANCE_BANKS: 'insuranceBanks',
  INSURANCE_MAIN_FETCH_STATES: 'insuranceMainFetchStates',
  IS_IN_CREDIT: 'isInCredit',
  LAST_MODIFIED_AT: 'lastModifiedAt',
  MIN_DRIVERS_AGE: 'minDriversAge',
  MIN_DRIVERS_EXPERIENCE: 'minDriversExperience',
  MULTIDRIVE: 'multidrive',
  NAMEPLATE: 'nameplate',
  SELECTED_BANK: 'selectedBank',
  WORKSHEET_ID: 'workSheetId',
};

export const FETCH_NAMES = {
  ADDING_NEW_APPLICATION: 'addingNewApllication',
  AGREEMENT: 'agreement',
  CALCULATE: 'calculate',
  CLIENT_DECLINE: 'clientDecline',
  GET_POLICY: 'getPolicy',
  SELECT_OFFER: 'selectOffer',
};

export const ERRORS = {
  FETCH_APPLICATION_DATA: 'fetch-application-data',
  NETWORK: 'network',
};
